export default "__VITE_ASSET__9b42b021__"